<template>
    <div class="px-2 pb-0 select-none">
        <div class="w-full relative pr-4 h-4 top-0 text-xs">
            <div class="h-1 border border-gray-200 rounded bg-white absolute top-1.5 w-full" ref="track"></div>
            <div :class="'h-1 border border-gray-200 rounded absolute top-1.5 w-full '+sliderColor"
                 :style="'width:'+currentPercent"></div>
            <div :class="'h-1 border border-gray-200 rounded absolute top-1.5 w-full '+minColor"
                 ref="min"
                 :style="'width:'+min" v-if="min"></div>
            <div class="w-full absolute top-0 select-none" style="padding-left:0rem; padding-right:2rem;">
                <div
                    class="top-0 h-4 bg-white w-8 border border-gray-300 bg-white rounded align-text-top text-gray-400 text-xs m-0 py-0 px-1 h-4 cursor-pointer"
                    @mousedown="startDragging"
                    :style="'line-height:0.95rem; margin-left:'+currentPercent"
                    v-text="math.floor(parseFloat(currentPercent))+'%'"></div>
            </div>
        </div>
    </div>

</template>

<script>
import * as math from "mathjs";

export default {
    components: {},
    props: {
        percent: String,
        min: false,
        max: false,
        readonly: false,
        minColor: {
            type: String,
            default: "bg-green-400",
        },
        sliderColor: {
            type: String,
            default: "bg-blue-400",
        },
    },
    data() {
        return {
            math,
            dragging: false,
        }
    },
    computed: {
        currentPercent() {
            let currentPercent = this.percent;
            if (this.min) {
                currentPercent = math.min(math.max(parseFloat(this.percent), parseFloat(this.min)), parseFloat(this.max ? this.max : 100)) + '%';
            }
            return currentPercent
        }
    },
    methods: {
        startDragging(event) {
            if (!this.readonly) {
                this.dragging = event.x
                event.preventDefault()
                event.stopPropagation()
                event.stopImmediatePropagation()
                return false;
            }
        },
        stopDragging(event) {
            if (!this.readonly) {
                this.dragging = false;
            }
        },
        updateIfDragging(event) {
            if (!this.readonly && (this.dragging !== false)) {
                event.preventDefault()
                event.stopPropagation()
                event.stopImmediatePropagation()
                if (event.buttons === 0) {
                    this.stopDragging(event);
                    return
                }
                let box = this.$refs.track.getBoundingClientRect();
                let perPixel = 100 / box.width;
                let eventX = math.min(event.x, (box.x+2) + ((box.width/100) * parseFloat(this.max ? this.max : 100)));
                let change = ((eventX - this.dragging) * perPixel);
                let newPercent = math.min(parseFloat(this.max ? this.max : 100), math.max(parseFloat(this.currentPercent) + change, parseFloat(this.min ? this.min : 0))) + '%';
                this.dragging = math.min(math.max(eventX, box.x), box.x + box.width);
                if (this.min) {
                    let box = this.$refs.min.getBoundingClientRect();
                    this.dragging = math.max(this.dragging, box.x + box.width);
                }
                this.$emit('change', newPercent)
                return false;
            }
        }
    },
    async mounted() {
        document.addEventListener("mousemove", this.updateIfDragging);
        document.addEventListener("mouseup", this.stopDragging);
    },
    beforeDestroy() {
        document.removeEventListener("mousemove", this.updateIfDragging);
        document.removeEventListener("mouseup", this.stopDragging);
    }
}
</script>
